<template>
    <v-dialog width="1100px" v-model="isOpenMove">
        <v-card elevation="0" >
            <v-card-title primary-title>
                <div v-if="$vuetify.breakpoint.xs" class="ml-2">
                    <p class="pa-0 primary--text text-overline">
                        <v-icon left> mdi-calendar-multiple </v-icon>
                        Copiar agendados
                    </p>
                    <v-switch
                        class="text-subtitle-1"
                        label="Filtros"
                        color="success"
                        inset
                        v-model="filters"
                    >
                    </v-switch>
                </div>
                <div
                    v-else
                    class="
                        d-flex
                        align-center
                        font-weight-light
                        primary--text
                        text-h4
                        ml-2
                    "
                    style="width: 100% !important"
                >
                    <div>
                        <v-icon large left> mdi-calendar-multiple </v-icon>
                        Copiar agendados
                    </div>
                    <div class="ml-auto">
                        <v-switch
                            class="ml-auto"
                            label="Filtros"
                            color="success"
                            inset
                            v-model="filters"
                        >
                        </v-switch>
                    </div>
                </div>
            </v-card-title>
            <!-- <!-- <v-divider class="test"></v-divider> --> -->
            <v-card-text class="py-2">
                <v-fade-transition>
                    <v-row v-if="filters" dense>
                        <v-col cols="12" md="6" class="px-1">
                            <v-card elevation="0" class="pt-2 px-4 my-1">
                                <v-row class="pb-3 pt-2">
                                    <h4
                                        class="
                                            font-weight-light
                                            primary--text
                                            px-2
                                        "
                                    >
                                        Filtrar por Rol
                                    </h4>
                                </v-row>
                                <!-- <v-divider class="mx-n1"></v-divider> -->
                                <v-row no-gutters>
                                    <v-select
                                        class="pa-4"
                                        :items="opciones.cuenta.rol"
                                        item-text="human"
                                        item-value="encoded"
                                        v-model="rol"
                                        persistent-hint
                                        :hint="
                                            rol.length
                                                ? 'Elimine los filtros para ver la selección completa'
                                                : ''
                                        "
                                        multiple
                                        prepend-inner-icon="mdi-gamepad-outline"
                                        label="Elija un rol"
                                        clearable
                                    >
                                        <template #item="{ item }">
                                            {{ item.human }}
                                        </template>
                                        <template #selection="{ item }">
                                            <v-chip
                                                small
                                                dark
                                                color="red lighten-1"
                                                >{{ item.human }}</v-chip
                                            >
                                        </template>
                                    </v-select>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-1">
                            <v-card elevation="0" class="pt-2 px-4 my-1">
                                <v-row class="pb-3 pt-2">
                                    <h4
                                        class="
                                            font-weight-light
                                            primary--text
                                            px-2
                                        "
                                    >
                                        Filtrar por Tipo
                                    </h4>
                                </v-row>
                                <!-- <v-divider class="mx-n1"></v-divider> -->
                                <v-row no-gutters>
                                    <v-select
                                        class="pa-4"
                                        :items="opciones.cuenta.tipoComercial"
                                        item-text="human"
                                        item-value="encoded"
                                        v-model="types"
                                        persistent-hint
                                        :hint="
                                            types.length
                                                ? 'Elimine los filtros para ver la selección completa'
                                                : ''
                                        "
                                        multiple
                                        prepend-inner-icon="mdi-filter"
                                        label="Elija un tipo"
                                        clearable
                                    >
                                        <template #item="{ item }">
                                            {{ item.human }}
                                        </template>
                                        <template #selection="{ item }">
                                            <v-chip
                                                small
                                                dark
                                                color="orange lighten-1"
                                                >{{ item.human }}</v-chip
                                            >
                                        </template>
                                    </v-select>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-fade-transition>
                <v-row dense>
                    <v-col cols="12" md="5" class="px-1">
                        <v-card elevation="0" class="pt-2 px-4">
                            <v-row class="pb-3 pt-2">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Comercial Origen
                                </h4>
                            </v-row>
                            <!-- <v-divider class="mx-n1"></v-divider> -->
                            <v-row no-gutters>
                                <v-autocomplete
                                    class="pa-4"
                                    :items="comercialesFilter"
                                    v-model="origin"
                                    :error-messages="
                                        origin == destination && origin
                                            ? 'Los comerciales deben ser distintos'
                                            : ''
                                    "
                                    item-text="nombreCompleto"
                                    item-value="id"
                                    prepend-inner-icon="mdi-account"
                                    label="Origen"
                                    clearable
                                >
                                    <template #item="{ item }">
                                        <v-row>
                                            <v-col cols="9">
                                                {{ item.nombreCompleto }}
                                            </v-col>
                                            <v-col cols="3">
                                                <v-icon
                                                    :color="
                                                        estadoComercial[
                                                            item.estado
                                                        ]
                                                    "
                                                    class="
                                                        d-flex
                                                        justify-center
                                                        overline
                                                    "
                                                >
                                                    mdi-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip small color="lime">{{
                                            item.nombreCompleto
                                        }}</v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col
                        v-if="$vuetify.breakpoint.smAndUp"
                        cols="2"
                        class="d-flex justify-center mt-16 pl-6"
                    >
                        <!-- <v-icon size="80">
                        mdi-chevron-triple-right
                    </v-icon> -->
                        <div class="arrow-container">
                            <div class="arrow-down"></div>
                        </div>
                        <div class="arrow-container">
                            <div class="arrow-down"></div>
                        </div>
                        <div class="arrow-container">
                            <div class="arrow-down"></div>
                        </div>
                        <div class="arrow-container">
                            <div class="arrow-down"></div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="5" class="px-1">
                        <v-card elevation="0" class="pt-2 px-4">
                            <v-row class="pb-3 pt-2">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Comercial Destino
                                </h4>
                            </v-row>
                            <!-- <v-divider class="mx-n1"></v-divider> -->
                            <v-row no-gutters>
                                <v-autocomplete
                                    class="pa-4"
                                    :items="comercialesFilter"
                                    v-model="destination"
                                    :error-messages="
                                        origin == destination && origin
                                            ? 'Los comerciales deben ser distintos'
                                            : ''
                                    "
                                    item-text="nombreCompleto"
                                    item-value="id"
                                    prepend-inner-icon="mdi-account"
                                    label="Destino"
                                    clearable
                                >
                                    <template #item="{ item }">
                                        <v-row>
                                            <v-col cols="9">
                                                {{ item.nombreCompleto }}
                                            </v-col>
                                            <v-col cols="3">
                                                <v-icon
                                                    :color="
                                                        estadoComercial[
                                                            item.estado
                                                        ]
                                                    "
                                                    class="
                                                        d-flex
                                                        justify-center
                                                        overline
                                                    "
                                                >
                                                    mdi-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip small color="lime">{{
                                            item.nombreCompleto
                                        }}</v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-tooltip bottom max-width="470px" color="grey darken-3">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            :disabled="
                                !destination || !origin || origin == destination
                            "
                            color="success"
                            @click="
                                submit();
                                close();
                            "
                            v-bind="attrs"
                            v-on="on"
                        >
                            Subir
                        </v-btn>
                    </template>
                    <v-row>
                        <v-col class="text-justify" cols="8">
                            Va a mover los agendados de
                            <strong>{{
                                origin
                                    ? comerciales.find(
                                          (item) => item.id == origin
                                      ).nombreCompleto
                                    : ''
                            }}</strong>
                            a
                            <strong>{{
                                destination
                                    ? comerciales.find(
                                          (item) => item.id == destination
                                      ).nombreCompleto
                                    : ''
                            }}</strong
                            >, proceda con cautela al realizar esta acción ya
                            que los cambios realizados podrían ser irreversibles
                            y afectar a la integridad de la información
                            almacenada en la base de datos. Si no está seguro de
                            lo que está haciendo, consulte con los
                            administradores.
                        </v-col>
                        <v-col cols="4" class="px-6 align-self-center">
                            <v-icon size="90" color="orange">
                                mdi-alert
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-tooltip>
                <v-btn
                    :disabled="isExporting"
                    text
                    color="red"
                    @click="close()"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'AddBadgeDialog',
    data: () => ({
        estadoComercial,
        types: [],
        rol: [],
        filters: false,
        origin: null,
        destination: null,
    }),
    methods: {
        close() {
            this.rol = [];
            this.types = [];
            this.origin = null;
            this.destination = null;
            this.isOpenMove = false;
        },
        submit() {
            this.$store.dispatch('areaPersonal/calendario/moveScheduled', {
                origin: this.origin,
                destination: this.destination,
            });
        },
        ...mapActions('areaPersonal/calculadora', ['moveScheduled']),
    },
    computed: {
        comercialesFilter() {
            return this.rol.length == 0 && this.types.length == 0
                ? this.comerciales
                : this.comerciales.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        isOpenMove: {
            get() {
                return this.$store.state.areaPersonal.calendario.isOpenMove;
            },
            set(value) {
                this.$store.commit('areaPersonal/calendario/isOpenMove', value);
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
            // opciones: (state) => state.opciones,
        }),
    },
};
</script>
<style scoped>
html,
body {
    height: 100%;
}
body {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.arrow-container {
    width: 25px;
    /* cubic-bezier-easing = sine / mehr Beispiele: https://easings.net/ */
    animation: bounce 1600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);
    cursor: pointer;
    height: 20px;
}

.arrow-down {
    height: 6px;
    background: rgb(255, 77, 77);
    transform: rotate(-45deg);
    transform-origin: 0% 0%;
    border-radius: 5px;
}
.arrow-down:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 100%;
    border-radius: 5px;
    background: rgb(255, 77, 77);
    transform: rotate(-90deg);
    transform-origin: 0% 100%;
}

@keyframes bounce {
    50% {
        transform: translateX(-15px);
    }
}
</style>